<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">票据</label>
            <em class="weui-form-preview__value">{{form.main.bap_billkind}}</em>
          </div>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd">
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">票据日期</label>
              <span class="weui-form-preview__value">{{dateFormat(form.main.bap_date,'yyyy-MM-dd')}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">出票日期</label>
              <span class="weui-form-preview__value">{{dateFormat(form.main.bap_date,'yyyy-MM-dd')}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">汇票号码</label>
              <span class="weui-form-preview__value">{{ form.main.bap_billcode }}</span>
            </div>
          </div>
        </div>
        <div class="form-preview ">
          <div class="weui-form-preview__bd">
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">出票人全称</label>
              <span class="weui-form-preview__value">{{form.main.bap_payname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">出票人账号</label>
              <span class="weui-form-preview__value">{{form.main.bap_paybankaccount}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">付款行全称</label>
              <span class="weui-form-preview__value">{{ form.main.bap_paybank }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">收款人全称</label>
              <span class="weui-form-preview__value">{{ form.main.bap_recname }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">收款人账号</label>
              <span class="weui-form-preview__value">{{ form.main.bap_recbankaccount }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">收款人开户银行</label>
              <span class="weui-form-preview__value">{{ form.main.bap_recbank }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">出票金额</label>
              <span class="weui-form-preview__value">{{ form.main.bap_amount }}{{ form.main.bap_currency }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">汇票到期日</label>
              <span class="weui-form-preview__value">{{ dateFormat(form.main.bap_duedate,'yyyy-MM-dd') }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">承兑协议编号</label>
              <span class="weui-form-preview__value">{{ form.main.bap_protocol }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">付款行行号</label>
              <span class="weui-form-preview__value">{{ form.main.bap_paybankcode }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">付款行地址</label>
              <span class="weui-form-preview__value">{{ form.main.bap_paybankaddr }}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">备注</label>
              <span class="weui-form-preview__value">{{ form.main.bap_remark }}</span>
            </div>
          </div>
        </div>
        <div class="form-preview weui-form-preview">
          <div class="weui-form-preview__bd">
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">付款类型</label>
              <span class="weui-form-preview__value">{{form.main.bap_kind}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">供应商名称</label>
              <span class="weui-form-preview__value">{{form.main.bap_vendname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">冲账币种</label>
              <span class="weui-form-preview__value">{{form.main.bap_cmcurrency}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">冲账汇率</label>
              <span class="weui-form-preview__value">{{form.main.bap_cmrate}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">冲账金额</label>
              <span class="weui-form-preview__value">{{numberFormat(form.main.bap_cmamount,'¥#,##0.00')}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">票据科目</label>
              <span class="weui-form-preview__value">{{form.main.bap_catename}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.bap_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.bap_auditman
            }}</span>
          </div>
        </div>
      </div>

      <file-list :value="form.main.bap_attach" />
    </div>
  </div>
</template>

<script>
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/money/billap",
      caller: "BillAP",
      xtype: "money-billap-formpanel",
    };
  },
};
</script>
